// Catálogo central de monedas soportadas por la app.
// Incluye EUR/USD/GBP originales + monedas de países hispanohablantes
// de Latinoamérica (códigos ISO 4217).
//
// "decimals" indica cuántos decimales usa normalmente cada moneda al
// mostrarla (el Guaraní paraguayo, por ejemplo, no suele usar decimales).

export const CURRENCIES = [
  { code: "EUR", symbol: "€",    label: "🇪🇺 Euro (€)",                    decimals: 2 },
  { code: "USD", symbol: "$",    label: "🇺🇸 Dólar EE.UU. (US$)",          decimals: 2 },
  { code: "GBP", symbol: "£",    label: "🇬🇧 Libra (£)",                   decimals: 2 },

  { code: "MXN", symbol: "$",    label: "🇲🇽 Peso mexicano (MX$)",         decimals: 2 },
  { code: "ARS", symbol: "$",    label: "🇦🇷 Peso argentino (AR$)",        decimals: 2 },
  { code: "COP", symbol: "$",    label: "🇨🇴 Peso colombiano (CO$)",       decimals: 0 },
  { code: "CLP", symbol: "$",    label: "🇨🇱 Peso chileno (CL$)",          decimals: 0 },
  { code: "PEN", symbol: "S/",   label: "🇵🇪 Sol peruano (S/)",            decimals: 2 },
  { code: "VES", symbol: "Bs.",  label: "🇻🇪 Bolívar venezolano (Bs.)",    decimals: 2 },
  { code: "GTQ", symbol: "Q",    label: "🇬🇹 Quetzal guatemalteco (Q)",    decimals: 2 },
  { code: "CUP", symbol: "$",    label: "🇨🇺 Peso cubano (CU$)",           decimals: 2 },
  { code: "BOB", symbol: "Bs.",  label: "🇧🇴 Boliviano (Bs.)",             decimals: 2 },
  { code: "DOP", symbol: "RD$",  label: "🇩🇴 Peso dominicano (RD$)",       decimals: 2 },
  { code: "HNL", symbol: "L",    label: "🇭🇳 Lempira hondureño (L)",       decimals: 2 },
  { code: "PYG", symbol: "₲",    label: "🇵🇾 Guaraní paraguayo (₲)",       decimals: 0 },
  { code: "NIO", symbol: "C$",   label: "🇳🇮 Córdoba nicaragüense (C$)",   decimals: 2 },
  { code: "CRC", symbol: "₡",    label: "🇨🇷 Colón costarricense (₡)",     decimals: 2 },
  { code: "PAB", symbol: "B/.",  label: "🇵🇦 Balboa panameño (B/.)",       decimals: 2 },
  { code: "UYU", symbol: "$U",   label: "🇺🇾 Peso uruguayo ($U)",          decimals: 2 },
];

// Mapa rápido código -> símbolo (compatibilidad con CURRENCY_SYMBOLS anterior)
export const CURRENCY_SYMBOLS = CURRENCIES.reduce((acc, c) => {
  acc[c.code] = c.symbol;
  return acc;
}, {});

// Mapa rápido código -> decimales
export const CURRENCY_DECIMALS = CURRENCIES.reduce((acc, c) => {
  acc[c.code] = c.decimals;
  return acc;
}, {});

export function getCurrencySymbol(code) {
  return CURRENCY_SYMBOLS[code] || "€";
}

// Formateador genérico de importes según la moneda activa.
// Uso: formatAmount(1234.5, "EUR") -> "€1.234,50"
export function formatAmount(n, code = "EUR") {
  const symbol = getCurrencySymbol(code);
  const decimals = CURRENCY_DECIMALS[code] !== undefined ? CURRENCY_DECIMALS[code] : 2;
  return symbol + Number(n).toLocaleString("es-ES", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
